import React from 'react';

const ThankYouSkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 pt-20 pb-32 animate-pulse">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-2xl w-full space-y-4">
        <div className="text-center space-y-2">
          <div className="w-16 h-16 mx-auto rounded-full bg-gray-200" />
          <div className="h-6 bg-gray-200 rounded w-2/3 mx-auto" />
          <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto" />
        </div>

        <div className="mt-6 space-y-4">
          <div className="h-4 w-1/4 bg-gray-200 rounded" />
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="flex items-center gap-4">
              <div className="w-16 h-16 bg-gray-200 rounded" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-2/3" />
                <div className="h-3 bg-gray-200 rounded w-1/3" />
              </div>
              <div className="h-4 bg-gray-200 w-12 rounded" />
            </div>
          ))}
          <div className="h-6 w-1/3 ml-auto bg-gray-300 rounded" />
        </div>

        <div className="h-12 bg-blue-300 rounded w-full mt-6" />
      </div>
    </div>
  );
};

export default ThankYouSkeleton;
